import React from 'react';
import { Section } from '../ui/Section';
import { Flame, Dumbbell, Moon, Wine, Brain } from 'lucide-react';
import { motion } from 'framer-motion';
export function TSAElements() {
  const elements = [{
    icon: Flame,
    title: 'COMBUSTIBLE',
    subtitle: '(Alimentación)',
    desc: 'Lo que comes determina la calidad de tu sangre y hormonas. Los alimentos procesados actúan como veneno para tu flujo sanguíneo.'
  }, {
    icon: Dumbbell,
    title: 'MOVIMIENTO',
    subtitle: '(Ejercicio)',
    desc: 'El tipo correcto de ejercicio dispara tu producción hormonal. El sedentarismo o el exceso de cardio la destruyen.'
  }, {
    icon: Moon,
    title: 'REGENERACIÓN',
    subtitle: '(Descanso)',
    desc: 'Tu cuerpo produce testosterona mientras duermes profundamente. Sin sueño reparador, tu motor funciona en vacío.'
  }, {
    icon: Wine,
    title: 'TOXINAS',
    subtitle: '(Alcohol y Drogas)',
    desc: 'Cada trago es un golpe directo a tu capacidad sexual. El alcohol adormece tu sistema nervioso central.'
  }, {
    icon: Brain,
    title: 'PRESIÓN',
    subtitle: '(Estrés)',
    desc: 'El cortisol es el asesino #1 de tu erección. Cuando estás en modo supervivencia, tu cuerpo apaga la función sexual.'
  }];
  return <Section data-id="element-184">
      <div className="text-center mb-16" data-id="element-185">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-186">
          Los 5 Elementos Que Determinan Tu{' '}
          <span className="text-brand-gold" data-id="element-187">Testosterona Sexual Activa</span>
        </h2>
        <p className="text-xl text-brand-muted max-w-2xl mx-auto" data-id="element-188">
          Para recuperar tu poder, debes dominar estos cinco pilares
          fundamentales.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-189">
        {elements.map((el, idx) => <motion.div key={idx} whileHover={{
        y: -5
      }} className={`bg-brand-card p-8 rounded-2xl border border-brand-gold/10 hover:border-brand-gold/30 transition-colors shadow-lg ${idx === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-190">
            <div className="w-14 h-14 rounded-full bg-brand-gold/10 flex items-center justify-center mb-6" data-id="element-191">
              <el.icon className="w-7 h-7 text-brand-gold" data-id="element-192" />
            </div>
            <h3 className="text-xl font-bold text-white mb-1 tracking-wide" data-id="element-193">
              {el.title}
            </h3>
            <p className="text-sm text-brand-gold/80 mb-4 font-medium" data-id="element-194">
              {el.subtitle}
            </p>
            <p className="text-gray-400 leading-relaxed" data-id="element-195">{el.desc}</p>
          </motion.div>)}
      </div>
    </Section>;
}